import { ReactElement } from 'react';
import { Link } from 'react-router-dom';

interface MultiGateBannerProps {
  referenceId: string;
}

/**
 * Shown on a multi-gate comparison session. Its configs, config values and runs are a mirror of the
 * reference session, rewritten by every sync — automatic after a reference edit, or Synchronise on the
 * Advanced → Multi-gate page. Lap exclusions made here are kept.
 */
export default function MultiGateBanner({ referenceId }: MultiGateBannerProps): ReactElement {
  return (
    <div className="cr-mb-4 cr-rounded-md cr-border cr-border-amber-300 cr-bg-amber-50 cr-p-3 cr-text-amber-900">
      This is a multi-gate comparison session. Its configs, calibration and runs mirror the{' '}
      <Link to={`/sessions/${referenceId}`} className="cr-font-semibold cr-underline">reference session</Link>,
      and follow it by themselves. Edits made here are overwritten at the next sync (see the{' '}
      <Link to={`/multi-gate?session=${referenceId}`} className="cr-font-semibold cr-underline">Multi-gate</Link>{' '}
      page), except lap exclusions, which belong to this session.
    </div>
  );
}
